import React from "react";
import {
  getMetaConnectInstructions,
  getMetaMappingInstructions,
  getMetaPageIdInstructions,
  getStaticInstructions,
} from "./inviteCopy";
import type { InvitePlatform } from "./inviteTypes";
import { InviteCalloutSteps } from "./InviteCallout";

export type InviteInstructionSet =
  | "platform-default"
  | "meta-page-id-fallback"
  | "meta-connect"
  | "meta-mapping";

export interface InviteInstructionsProps {
  platform: InvitePlatform;
  instructionSet?: InviteInstructionSet;
  /** @deprecated Use instructionSet="meta-page-id-fallback" */
  showMetaPageIdSteps?: boolean;
}

function resolveSteps(
  platform: InvitePlatform,
  instructionSet: InviteInstructionSet,
): string[] {
  switch (instructionSet) {
    case "meta-page-id-fallback":
      return getMetaPageIdInstructions();
    case "meta-connect":
      return getMetaConnectInstructions();
    case "meta-mapping":
      return getMetaMappingInstructions();
    default:
      return getStaticInstructions(platform);
  }
}

export const InviteInstructions: React.FC<InviteInstructionsProps> = ({
  platform,
  instructionSet = "platform-default",
  showMetaPageIdSteps = false,
}) => {
  const resolvedSet = showMetaPageIdSteps
    ? "meta-page-id-fallback"
    : instructionSet;
  const steps = resolveSteps(platform, resolvedSet);

  return (
    <InviteCalloutSteps
      title="Para aceptar esta invitación:"
      steps={steps}
    />
  );
};

export default InviteInstructions;
